
window.onload = function() {
};

$(function(){
  if($('.js-story-slider').length > 0 ){
    var num = $('.js-story-slider').attr('data-slideNum');
    var storySwiper = new Swiper(".js-story-slider", {
      initialSlide : num,
      slidesPerView: 2,
      centeredSlides: true,
      slidesPerView: "auto",
      //loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          if(index == 99){//ex01
            return '<div class="pagination_item ' + className + '"><a href="javascript:void(0)">EX</a></div>';
          }else{
            return '<div class="pagination_item ' + className + '"><a href="javascript:void(0)">' + (index) + "</a></div>";
          }
        },
      },
    });
  }

  if($('.js-chara-slider').length > 0 ){
    var charaSwiper = new Swiper(".js-chara-slider", {
      slidesPerView: "auto",
      freeMode: true,
      loop: true,
      loopAdditionalSlides: 1,
      loopFillGroupWithBlank: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".chara_swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<div class="pagination_item ' + className + '"><a //href="javascript:void(0)">' +  (index + 1) + "</a></div>";
        },
      },
    });
  }

  $('[data-fancybox="chara_modal"]').fancybox({
    toolbar: false, // ツールバーの非表示smallBtn:false
    smallBtn : false,
    infobar: false,
    arrows: false,
    autoFocus: false,
    backFocus: false,
    trapFocus: false,
    loop: true
  });

  $(`.js-togglebtn`).on(`click` , function () {
    $(`.js-toggle`).slideToggle(200);
    $(`.js-nav`).toggleClass(`is-close`);
  })

  $(`.js-langbtn`).on(`click` , function () {
    $(`.js-langlist`).slideToggle(200);
  })
});

$(function () {
  $('a[href*="#"]').click(function () {
    const speed = 400;
    const target = $(this.hash === '#' || '' ? 'html' : this.hash)
    if (!target.length) return;
    const targetPos = target.offset().top;
    $('html, body').animate({ scrollTop: targetPos }, speed, 'swing');
    return false;
  });
});